import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';

const KidScriptField = ({ source, record = {} }) => (
  <Typography
    variant="body1"
  >
    <pre>
      {record[source]}
    </pre>
  </Typography>
);

KidScriptField.propTypes = {
  source: PropTypes.string,
  record: PropTypes.object,
};

KidScriptField.defaultProps = {
  addLabel: true,
};

export default KidScriptField;

